export default __webpack_public_path__ + "static/media/Delete.55982133.svg";